import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ITableDataApiRes } from '../models/http.model';
import { IGetSubjectOption } from '../models/kps.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class KpsService {

  constructor(private httpService: HttpService) { }

  getKpsClass(): Observable<ITableDataApiRes> {
    return this.httpService.get('/share/kps/class');
  }

  getKpBySubject(subjectId: string): Observable<ITableDataApiRes> {
    return this.httpService.get(`/share/kps/subject/${subjectId}/kp`);
  }

  getSubjectByClass(params?: IGetSubjectOption): Observable<ITableDataApiRes> {
    return this.httpService.get(`/share/kps/class/${params?.classId}/subject`, { params })
  }
}
